import { Outlet, createFileRoute } from '@tanstack/react-router'

/** Layout for the availability section: the index grid + the `$id` editor render here. */
export const Route = createFileRoute('/_authed/bookings/availability')({
  component: () => <Outlet />,
})
